import { OrderTableData } from '@teinor/erp/prices/quote/totals'
import { CashRegisterModelType } from '@teinor/erp/types/company/cashRegister'
import { HeaderDataCalculate } from '@teinor/erp/types/company/order/general'
import { SellTicketProductModelTypeExtended } from '@teinor/erp/types/company/order/sell/sellTicket/sellTicketProduct'
import { memo, useCallback, useEffect, useState } from 'react'
import { DisplayPriceGettingParams } from '../../../../../../../../../../../baseComponents/Displays/DisplayPrice'
import { CalculateParamsTy } from '../../../../../../../../../../../baseComponents/Displays/DisplayPrice/types'
import LoadingSpinner from '../../../../../../../../../../../baseComponents/LoaderDecider/LoadingSpinner'
import { ModalOpenedSetTy } from '../../../../../../../../../../../baseComponents/Modal/types'
import { ButtonConfigColumnsWithModal } from '../../../../../../../../../../../baseComponents/ModalsLayouts/ModalConfigColumnsTabs'
import NullComponent from '../../../../../../../../../../../baseComponents/NullComponent'
import { SearchBarWithDebounce } from '../../../../../../../../../../../baseComponents/SearchBar'
import { ITDiscountDisplay, ITTypeQuantityDisplay } from '../../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays'
import { ITHookFunctionTy } from '../../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { InputTableURLsTable } from '../../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import TableWithCustomVirtualListing from '../../../../../../../../../../../baseComponents/TwinTable/TableWithCustomVirtualListing'
import { CustomRenderString } from '../../../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import FooterInputTableModalSelect from '../../../../../../../../../../../specificComponents/inputTableLayouts/FooterInputTableModalSelect'
import { ColumnOrderTableSchema } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/types'
import { parseSelectedTableDataForRefund } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/useMultiOrderRefundLogic/functions'
import { parseOrderTableData } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderQuoteLayout/function'
import { sellTicketLayoutComponents } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout'
import { InputTableSellTicketLayoutProps, TPVOrderData } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/types'
import useSellTicketLayoutTableLogic from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/useSellTicketLayoutTableLogic'
import { ProductExtendedTyInputTableListing } from '../../../../../../../../../../../specificComponents/Product/types'
import { memoChecker } from '../../../../../../../../../../../utils/globals/components'
import { twinFetchPostJSON } from '../../../../../../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../../../../../../utils/globals/dictionary'
import { ChangeValueFunc, Modify } from '../../../../../../../../../../../utils/globals/types'
import useConfigColumns from '../../../../../../../../../../../utils/hooks/useConfigColumns'
import useEditDeleteModal from '../../../../../../../../../../../utils/hooks/useEditDeleteModal'
import { usePlainMeasureDictionary } from '../../../../../../../../../../../utils/hooks/useMeasureDictionary'
import useTwinTranslation from '../../../../../../../../../../../utils/hooks/useTwinTranslation'
import { getAllWorkingCenters, getISOCurrencyMain, getPreparePricesConfigParam } from '../../../../../../../../../../../utils/reducers/getters'
import { changeErrorMessage } from '../../../../../../../../../../../utils/reducers/reduxDispatch'
import { parsedTicketTableData } from '../../../../../../functions'
import ModalPaymentMethodTPV from '../../../../ModalPaymentMethodTPV'
import ModalPaymentMethodInfoTPV from '../../../../ModalPaymentMethodTPV/ModalPaymentMethodInfoTPV'
import ModalWarehouseTPV from '../../../../ModalWarehouseTPV'
import ModalProcessSellTicketRefund from './ModalProcessTicketRefund'


type TableSellTicketForRefundListingProps = TableSellTicketForRefundListingLogicProps & {
    setOpened: ModalOpenedSetTy

}

interface SellTicketProductModelTypeExtendedWithRefund extends SellTicketProductModelTypeExtended {
    restRefundQuantity: number
    totalRefund: boolean,
    returnStock: boolean
}

const TableSellTicketForRefundListing: React.FC<TableSellTicketForRefundListingProps> = ({ ...rest }) => {
    const { t } = useTwinTranslation()
    const { completeData, setCompleteData, openModal, setOpenModal, handleCloseModal, handleOpenProcessSellTicketRefund } = useTableSellTicketForRefundListingLogic({ ...rest })
    const measures: any = usePlainMeasureDictionary()
    if (!completeData) {
        return <LoadingSpinner/>
    }
    const tableData = parseSelectedTableDataForRefund(completeData) as OrderTableData
    const calculateParams = getPreparePricesConfigParam() as CalculateParamsTy
    const headerDataCalculate: HeaderDataCalculate = {
        OrderCosts: [],
        ParamsRoundingDecimals: calculateParams,
        total_recharge_after: completeData?.header?.total_recharge_after,
        OrderShipping: {} as any,
        isFinished: completeData?.header?.isFinished,
        OrderAccounts: []
    }
    const parsedTableData = parseOrderTableData(tableData, headerDataCalculate)
    const footerDiscounts = []
    if (parsedTableData.totals.discounts_after) {
        footerDiscounts.push(
            {
                label: t('discount', 'Descuento'),
                children: <span className='medium14'><DisplayPriceGettingParams CurrencyId={completeData?.header?.CurrencyId} value={parsedTableData.totals.discounts_after} with_vat={false} /></span>,
            },
        )
    }
    const footerUnits = []
    for (const unit of parsedTableData.typeUnitsUsed) {
        const label = measures[unit]
        footerUnits.push(
            {
                label,
                children: <span className='medium14'><DisplayPriceGettingParams CurrencyId={''} value={parsedTableData?.totals?.units[unit] || 0} with_vat={false} /></span>
            },
        )
    }
    const footerLeftComponents = [
        ...footerUnits,
        ...footerDiscounts,
        {
            label: t('totalToRefundBig', 'TOTAL a devolver'),
            children: <span className='medium16'><DisplayPriceGettingParams CurrencyId={completeData?.header?.CurrencyId} value={parsedTableData.totals.total} with_vat={false} /></span>
        }
    ]
    const buttonCreateDisabled = !completeData?.selectedTableData?.length || (parseFloat(String(parsedTableData.totals.total)) > parseFloat(String(completeData?.header?.total_total)))
    return (
        <div className='flex flex-auto flex-col '>
            <InputTableSellTicketRefund className='modal_refund_table' userPermissions={{ n: 1, permission: 'read' }} completeData={completeData} setCompleteData={setCompleteData as any} getCompleteData={async () => { }} inputTableURLs={{} as any} orderHeaderURLs={{} as any} setTableConfiguration={() => { }} tableConfiguration={{} as any} name='sellTicketProductsForRefund' hookFunction={useSellTicketLayoutTableLogic} components={sellTicketLayoutComponents} title={''} TableButtons={NullComponent} modelId={'SellTicketId'} />
            <FooterInputTableModalSelect footerLeftComponents={footerLeftComponents} onAccept={handleOpenProcessSellTicketRefund} setOpened={rest.setOpened} textAccept={t('createRefund', 'Crear devolución')} textCancel={t('cancel', 'Cancelar')} disabled={buttonCreateDisabled} />
            {openModal?.type === 'edit' ? <ModalProcessSellTicketRefund setOpenModal={setOpenModal} allRowData={openModal?.allRowData} url={'/api/app/order/tpv/sellTicketRefund/createSellTicketRefund'} /> : null}
            {openModal?.type === 'create' && openModal?.allRowData?.type === 'Warehouse' ? <ModalWarehouseTPV setOpenModal={setOpenModal} allRowData={openModal?.allRowData} /> : null}
            {openModal?.type === 'create' && openModal?.allRowData?.type !== 'Warehouse' ? <ModalPaymentMethodTPV completeData={completeData} setOpenModal={setOpenModal} url={''} onSubmit={(rest.handleOnSubmitProcessSellTicketRefund)} isRefund={true} openModal={openModal} allRowData={openModal?.allRowData} /> : null}
            {openModal?.type === 'delete' ? <ModalPaymentMethodInfoTPV setOpenModal={setOpenModal} allRowData={openModal?.allRowData} isRefund={true} handleCloseModal={handleCloseModal} inputTableURLs={rest.inputTableURLs} /> : null}
        </div>
    )
}

interface TableSellTicketForRefundListingLogicProps {
    inputTableURLs: InputTableURLsTable
    cashRegister: CashRegisterModelType | undefined
    setOpened: ModalOpenedSetTy
    handleOnSubmitProcessSellTicketRefund: () => Promise<void>
}

const useTableSellTicketForRefundListingLogic = ({ inputTableURLs, cashRegister, setOpened, handleOnSubmitProcessSellTicketRefund }: TableSellTicketForRefundListingLogicProps) => {
    const { t } = useTwinTranslation()
    const [completeData, setCompleteData] = useState<TPVOrderData | null>(null)
    const { openModal, setOpenModal } = useEditDeleteModal()
    const noWarehousesError = t('notWorkingCenterAssignedWarehouse', 'No puedes efectuar la devolución debido a que no tienes ningún almacén asignado a tu centro de trabajo')

    const getCompleteData = useCallback(async () => {
        const getDataStr = JSON.stringify(inputTableURLs.getData)
        const getDataParsed = JSON.parse(getDataStr)
        let result: TwinDictionary = {}
        if (getDataParsed[1].id) {
            result = await twinFetchPostJSON(getDataParsed[0], { id: getDataParsed[1].id, full_assigned_number: getDataParsed[1].full_assigned_number, includeRelations: true })
            if (result) {
                setCompleteData((old) => {
                    let copyOld = JSON.parse(JSON.stringify(old || {}))
                    copyOld.tableData = result.tableData
                    copyOld.header = result.header
                    copyOld.header['OrderFinancialRows'] = null
                    copyOld.cashRegister = cashRegister
                    copyOld = parsedTicketTableData(copyOld, true)
                    return copyOld
                })
            }
        }
    }, [setCompleteData, inputTableURLs.getData, cashRegister])

    const handleCloseModal = useCallback(async() => {
        await handleOnSubmitProcessSellTicketRefund()
        setOpenModal(null)
        setOpened(null)
    }, [setOpened, setOpenModal, handleOnSubmitProcessSellTicketRefund])

    const handleOpenProcessSellTicketRefund = useCallback(() => {
        if (completeData?.selectedTableData?.length) {
            const workingCenters = getAllWorkingCenters()
            const warehouses = workingCenters?.[completeData?.cashRegister?.WorkingCenterId || 0]?.Warehouses
            if (warehouses?.length) {
                let hasWarehouseSelected = true
                for (const element of completeData?.selectedTableData) {
                    const product = completeData.tableData[completeData.dictPosTableData[element.id]]
                    if (!product.WarehouseId) {
                        hasWarehouseSelected = false
                        break
                    }
                }
                const myData: TwinDictionary = completeData
                if (!hasWarehouseSelected && warehouses.length > 1) {
                    myData['type'] = 'Warehouse'
                } else {
                    myData['type'] = 'PaymentMethods'
                    myData['WarehouseId'] = warehouses[0].id 
                }
                setOpenModal({ type: 'create', allRowData: { ...myData} })
            } else {
                changeErrorMessage(noWarehousesError)
            }
        }
    }, [completeData, setOpenModal, noWarehousesError])
   
    useEffect(() => {
        getCompleteData()
    }, [getCompleteData])

    return { completeData, setCompleteData, openModal, setOpenModal, handleCloseModal, handleOpenProcessSellTicketRefund }
}


type InputTableSellTicketRefundProps = Modify<InputTableSellTicketLayoutProps, {
    hookFunction: ITHookFunctionTy
    columns?: never
}>

const InputTableSellTicketRefund: React.FC<InputTableSellTicketRefundProps> = ({ completeData, setCompleteData, hookFunction, title, name, ...rest }) => {
    const currency = getISOCurrencyMain()
    const {t} = useTwinTranslation()
    const workingCenters = getAllWorkingCenters()
    const dictWarehouses = workingCenters?.[completeData?.cashRegister?.WorkingCenterId || 0]?.dictWarehouses
    const columns: ColumnOrderTableSchema<ProductExtendedTyInputTableListing & SellTicketProductModelTypeExtendedWithRefund> = [
        {
            id: 'selected',
            dataKey: 'selected',
            label: '',
            simpleLabel: t('selectLine', 'Seleccionar línea'),
            width: 50,
            requiredColumn: true,
            component: 'ITCheckbox',
            headerClassName: 'checkbox_header_filter',
            extraProps: { readOnlyFnc: (allRowData: any) => allRowData?.totalRefund },
            searchableComponent: {
                component: 'SearchableComponentsCustomSelect',
                extraComponentData: { items: { 'unprocessed': { name: t('unprocessed', 'Sin procesar') }, 'processed': { name: t('processed', 'Procesados') } }, label: t('show', 'Mostrar') },
            }
        },
        {
            id: 'nLine',
            dataKey: 'nLine',
            label: t('line', 'Línea'),
            width: 70,
            hideColumnByDefault: true
        },
        {
            id: 'url',
            dataKey: 'url',
            label: t('image', 'Imagen'),
            component: 'ITDisplayImage',
            width: 70
        },
        {
            id: 'code_bar',
            dataKey: 'code_bar',
            label: t('codeBarShort', 'Cod. de barras'),
            simpleLabel: t('codeBar', 'Código de barras'),
            component: 'OrderSearchProductInputCreate',
            field: 'code_bar',
            typeOnChange: 'onChangeAdd',
            sortable: true,
            hideColumnByDefault: true,
            minWidth: 115
        },
        {
            id: 'reference',
            dataKey: 'reference',
            label: t('reference', 'Referencia'),
            component: 'OrderSearchProductInput',
            field: 'reference',
            sortable: true,
            minWidth: 100,
            hideColumnByDefault: true,
            className: 'quote_order_reference_name'
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            component: 'OrderSearchProductInputName',
            field: 'name',
            sortable: true,
            hideColumnByDefault: true,
            className: 'quote_order_reference_name'
        },
        {
            id: 'referenceAndName',
            dataKey: 'name',
            label: t('referenceName', 'Referencia y nombre'),
            component: 'OrderSearchProductInputReferenceAndName',
            field: 'referenceAndName',
            sortable: true,
            minWidth: 180,
            className: 'quote_order_reference_name',
        },
        {
            id: 'descriptionDocuments',
            dataKey: 'descriptionDocuments',
            label: t('description', 'Descripción'),
            customRender: (parameterValue) => <CustomRenderString value={parameterValue} className='twin_elipsis' />,
            hideColumnByDefault: true
        },
        {
            id: 'shortDescriptionDocuments',
            dataKey: 'shortDescriptionDocuments',
            label: t('shortDescriptionS', 'Desc. corta'),
            simpleLabel: t('shortDescription', 'Descripción corta'),
            customRender: (parameterValue) => <CustomRenderString value={parameterValue} />,
            hideColumnByDefault: true
        },
        {
            id: 'notes',
            dataKey: 'notes',
            label: t('notes', 'Notas'),
            customRender: (parameterValue, allRowData) => <CustomRenderString value={parameterValue} className='twin_elipsis' />,
            hideColumnByDefault: true
        },
        {
            id: 'initialUnitPriceWithTax',
            dataKey: 'initialUnitPriceWithTax',
            label: () => <div className='text-right mr-15 w-full'>{t('price', 'Precio')}</div>,
            simpleLabel: t('price', 'Precio'),
            component: 'ITDisplayPrice',
            width: 100,
        },
        {
            id: 'quantity',
            dataKey: 'quantity',
            label: t('quantity', 'Cantidad'),
            width: 110,
            component: 'ITInputQuantityRefund',
            typeOnChange: 'onChangeTotals',
            applyMaxValue: true,
        },
        {
            id: 'restRefundQuantity',
            dataKey: 'restRefundQuantity',
            label: t('restQuantityShort', 'Cant. rest.'),
            simpleLabel: t('restQuantity', 'Cantidad restante'),
            toolTip: t('restQuantity', 'Cantidad restante'),
            width: 110,
            component: 'ITInputQuantityRefund',
            readOnlyFnc: () => true
        },
        {
            id: 'desiredQuantity',
            dataKey: 'desiredQuantity',
            label: t('invoicedQuantityShort', 'Cant. fact.'),
            simpleLabel: t('invoicedQuantity', 'Cantidad facturada'),
            toolTip: t('invoicedQuantity', 'Cantidad facturada'),
            width: 110,
            component: 'ITInputQuantity',
            readOnlyFnc: () => true
        },
        {
            id: 'quantity2',
            dataKey: 'quantity2',
            label: t('quantitySecondRes', 'Cant. sec.'),
            simpleLabel: t('quantitySecondary', 'Cantidad secundaria'),
            width: 90,
            customRender: (parameterValue, allRowData) => <ITTypeQuantityDisplay measure={allRowData.typeQuantity2} value={parameterValue} />,
            hideColumnByDefault: true
        },
        {
            id: 'wasteWeight',
            dataKey: 'wasteWeight',
            label: t('wasteWeight', 'Merma'),
            customRender: (parameterValue) => <CustomRenderString value={parameterValue ? parameterValue + ' %' : ''} />,
            width: 100,
            hideColumnByDefault: true,
        },
        {
            id: 'discount',
            dataKey: 'discount',
            label: t('discount', 'Descuento'),
            width: 90,
            customRender: (parameterValue, allRowData) => <ITDiscountDisplay CurrencyId={completeData?.header.CurrencyId} value={parameterValue} typeDiscount={allRowData.typeDiscount} decimals={2} />
        },
        {
            id: 'rowPriceWithoutTaxPrev',
            dataKey: 'rowPriceWithoutTaxPrev',
            label: () => <div className='text-right mr-15 w-full'>{t('rowPrice', 'Precio Línea')}</div>,
            simpleLabel: t('rowPrice', 'Precio Línea'),
            component: 'ITDisplayFinalPrice',
            hideColumnByDefault: true,
            with_vat: false,
            width: 120
        },
        {
            id: 'rowPriceWithoutTaxAndTotalDiscount',
            dataKey: 'rowPriceWithoutTaxAndTotalDiscount',
            label: () => <div className='text-right w-full'>{t('priceTotal', 'Precio Total')}</div>,
            simpleLabel: t('priceTotal', 'Precio Total'),
            component: 'ITDisplayFinalPrice',
            with_vat: false,
            width: 120,
            hideColumnByDefault: true,
        },
        {
            id: 'rowPriceWithTaxAndTotalDiscount',
            dataKey: 'rowPriceWithTaxAndTotalDiscount',
            label: () => <div className='text-right w-full'>{t('totalPriceWithTaxShort', 'Precio Total Imp.')}</div>,
            simpleLabel: t('totalPriceWithTaxShort', 'Precio Total Imp.'),
            component: 'ITDisplayPrice',
            with_vat: false,
            width: 130,
        },
        {
            id: 'totalWithTaxWithComplements',
            dataKey: 'totalWithTaxWithComplements',
            simpleLabel: t('totalWithComplementsAndVat', 'Total con complementos e imp.'),
            label: () => <div className='text-right w-full' >{t('withComplementsAndVatS', 'Con comp. e imp.')}</div>,
            component: 'ITDisplayPrice',
            width: 160,
            hideColumnByDefault: true,
            toolTip: t('totalWithComplementsAndVatL', 'Total con complementos e impuestos'),
        },
        {
            id: 'totalWithoutTaxWithComplements',
            dataKey: 'totalWithoutTaxWithComplements',
            simpleLabel: t('totalWithComplements', 'Total con complementos'),
            label: () => <div className='text-right w-full'> {t('withComplementsS', 'Con comp.')}</div>,
            component: 'ITDisplayPrice',
            width: 110,
            hideColumnByDefault: true,
            toolTip: t('totalWithComplements', 'Total con complementos')
        },
        {
            id: 'totalWithoutTaxWithComplementsPrev',
            dataKey: 'totalWithoutTaxWithComplementsPrev',
            simpleLabel: t('totalWithoutTaxWithComplementsPrev', 'Total con complementos antes de desc.'),
            label: () => <div className='text-right w-full'> {t('withComplementsS', 'Con comp.')}</div>,
            component: 'ITDisplayPrice',
            width: 110,
            hideColumnByDefault: true,
            toolTip: t('totalWithoutTaxWithComplementsPrev', 'Total con complementos antes de descuentos'),
        },
        {
            id: 'unique_number',
            dataKey: 'unique_number',
            label: t('uniqueNumberShort', 'Nº único'),
            simpleLabel: t('uniqueNumber', 'Número único'),
            toolTip: t('uniqueNumber', 'Número único'),
            component: 'OrderUniqueNumberProductReadOnly',
            hideColumnByDefault: true,
        },
        {
            id: 'returnStock',
            dataKey: 'returnStock',
            label: t('returnStockShort', 'Dev. stock'),
            simpleLabel: t('returnStock', 'Devolver stock'),
            toolTip: t('returnStock', 'Devolver stock'),
            component: 'ITOrderBooleanRectangle',
            hideColumnByDefault: true,
            translations: { positive: t('yes', 'Sí'), negative: t('no', 'No') },
            typeOnChange: 'onChange',
            width: 105,
        },
        {
            id: 'WarehouseId',
            dataKey: 'WarehouseId',
            label: t('warehouse', 'Almacén'),
            component: 'ITInputSelectWarehouses',
            minWidth: 110,
            hideColumnByDefault: true,
            items: dictWarehouses || [],
            readOnlyFnc: (allRowData) => allRowData?.processed,
            typeOnChange: 'onChange'
        },
    ]
    const { setSelectedColumnsAndFilters, memorizedColumns, selectedColumnsAndFilters } = useConfigColumns({ columns, name })
    const { parsedColumns, rowRenderer, containerRenderer, onChangeSearchBar, filters, ...resty } = hookFunction({ completeData: completeData as any, columns: memorizedColumns, CurrencyId: currency, setCompleteData: setCompleteData as any, ...rest })
    const parsedTableData = completeData?.filteredTableData || completeData?.tableData
    const parseFilteredData = useCallback((rowIndex: number) => {
        return completeData?.tableData?.[completeData.dictPosTableData?.[parsedTableData?.[rowIndex].id]]
    }, [completeData?.dictPosTableData, completeData?.tableData, parsedTableData])
    return (
        <div className='flex flex-auto flex-col gap-8 overflow-hidden input_table_whitebox '>
            <div className='flex flex-wrap gap-10 justify-between items-center'>
                <SearchBarInputTable onChange={onChangeSearchBar} />
                <div>
                    <ButtonConfigColumnsWithModal name={name} columns={columns} setSelectedColumnsAndFilters={setSelectedColumnsAndFilters} selectedColumnsAndFilters={selectedColumnsAndFilters} haveFiltersColumn={false} setTableConfiguration={() => { }} getTableDataFromStart={() => { }} />
                </div>
            </div>
            <div className='flex flex-auto overflow-auto input_table_table'>
                <TableWithCustomVirtualListing columns={parsedColumns} data={parsedTableData || []} rowRenderer={rowRenderer} containerRenderer={containerRenderer} setSelectedColumnsAndFilters={setSelectedColumnsAndFilters} name={name} updateEmployeeParameter={true} headerChanges={{ changeOrder: () => { }, changeSingleField: resty.eventFunctions.changeSingleField }} filters={filters} getDataFnc={completeData?.filteredTableData ? parseFilteredData : undefined as any} />
            </div>
            <div style={{ height: 50 }}></div>
        </div>

    )
}

interface SearchBarInputTableProps {
    onChange: ChangeValueFunc
}

const SearchBarInputTable: React.FC<SearchBarInputTableProps> = memo(({ onChange }) => {
    const { t } = useTwinTranslation()
    return (
        <SearchBarWithDebounce className='search_bar_table' searchValue='' onChange={onChange} placeholder={t('search', 'Buscar')} debounce={300} />
    )
}, (oldProps, nextProps) => memoChecker(oldProps, nextProps, ['onChange']))


export default TableSellTicketForRefundListing
